import { useState,useRef } from "react";
import { Select, MenuItem, Button, Alert, Snackbar } from "@mui/material";
import CompanyAutoselect from "../Universal/CompanyAutoselect";
import { format } from "date-fns";
import axios from "axios";
import FinancialPicker from "./FinancialPicker";
import FinancialStepper from "./FinancialStepper";
import Model from "../Model.js";
import { useEffect } from "react";

export default function AdminEdit(props) {

    let defaultFinancial = Model;
    const [selectedCompany,setSelectedCompany]=useState(null);
    const[financials,setFinancials]=useState([]);
    const[selectedFinancial,setSelectedFinancial]=useState(defaultFinancial);
    const [displayStepper,setDisplayStepper]=useState(true);
    const [selectedFid,setSelectedFid]=useState(0);
    const [divisions,setDivisions]=useState([]);
    const [filteredFinancials,setFilteredFinancials]=useState([]);
    const [selectedDivision,setSelectedDivision]=useState('');
    const [peers,setPeers]=useState([]);
    const [uploadError, setUploadError] = useState('');
    const [showError, setShowError] = useState(false);
    const [uploadSuccess, setUploadSuccess] = useState('');
    const [showSuccess, setShowSuccess] = useState(false);
    const [isUploading, setIsUploading] = useState(false);

    const refreshPeers = () => {
        axios({
            url: process.env.REACT_APP_API_URL + 'PeerGroup',
            method: "Get",
            data: {},
        }).then((res) => {
            // Set peer groups with their full data including IDs
            setPeers(res.data);
        }).catch((err) => {
            console.log(err);
        });
    };

    const assignCompany=(company)=>{
        setSelectedCompany(company);
        refreshFinancials(company.companyId);
        refreshPeers(); // Load peer groups when company is assigned
    };
    // const refreshPeers = () => {
    //     axios({
    //         url: process.env.REACT_APP_API_URL + 'PeerGroup',
    //         method: "Get",
    //         data: {},
    //     }).then((res) => {
    //         // Extract unique divisions from the data
    //         setPeers(res.data);
    //     }).catch((err) => {
    //         console.log(err)
    //     });
    // }
    const submitSelectedFinancial = (e)=>
    {
        console.log('AdminEdit: Submitting financial with peerGroupId:', selectedFinancial.peerGroupId);
        console.log('AdminEdit: Full financial data:', selectedFinancial);
        
        // Set loading state
        setIsUploading(true);
        setUploadError('');
        setShowError(false);
        setUploadSuccess('');
        setShowSuccess(false);
        
        axios({
            // Endpoint to send files
            url: process.env.REACT_APP_API_URL+'FiscalInput',
            method: "PUT",
            data:{ ...selectedFinancial },
            }).then((res) => {
                // Clear loading state
                setIsUploading(false);
                
                // Check if response status is in 2xx range
                if (res.status >= 200 && res.status < 300) {
                    // Success - show success message
                    setUploadSuccess('Fiscal report updated successfully!');
                    setShowSuccess(true);
                    
                    // Wait a moment to show success message, then proceed
                    setTimeout(() => {
                        setSelectedFinancial(null);
                        setSelectedFid(0);
                        setDisplayStepper(false);
                        refreshFinancials();
                        setShowSuccess(false);
                    }, 2000);
                } else {
                    // Non-2xx response - treat as error
                    let errorMessage = 'Unexpected response from server. Please try again.';
                    if (res.data && res.data.message) {
                        errorMessage = res.data.message;
                    }
                    
                    setUploadError(errorMessage);
                    setShowError(true);
                    
                    // Don't change screens - keep user on current form
                }
            }).catch((err) => {
                // Clear loading state
                setIsUploading(false);
                
                console.log(err);
                
                // Set error message and show error notification
                let errorMessage = 'Failed to update fiscal report. Please try again.';
                
                if (err.response) {
                    // Server responded with error status
                    if (err.response.status === 400) {
                        errorMessage = 'Invalid data provided. Please check your input and try again.';
                    } else if (err.response.status === 401) {
                        errorMessage = 'Authentication failed. Please log in again.';
                    } else if (err.response.status === 403) {
                        errorMessage = 'You do not have permission to update this report.';
                    } else if (err.response.status === 500) {
                        errorMessage = 'Server error occurred. Please try again later.';
                    } else if (err.response.data && err.response.data.message) {
                        errorMessage = err.response.data.message;
                    } else {
                        errorMessage = `Server returned status ${err.response.status}. Please try again.`;
                    }
                } else if (err.request) {
                    // Network error
                    errorMessage = 'Network error. Please check your connection and try again.';
                }
                
                setUploadError(errorMessage);
                setShowError(true);
                
                // Don't change screens - keep user on current form
                // The stepper will remain active so user can fix issues and retry
            });
    }

    const handleCloseError = () => {
        setShowError(false);
    };

    const handleCloseSuccess = () => {
        setShowSuccess(false);
    };

    // Update filtered financials when division selection changes
    useEffect(() => {
        if (selectedDivision === '') {
            setFilteredFinancials(financials);
        } else {
            setFilteredFinancials(financials.filter(f => f.division === selectedDivision));
        }
    }, [selectedDivision, financials]);

    const handleDivisionChange = (e) => {
        setSelectedDivision(e.target.value);
        setSelectedFid(0); // Reset financial selection when division changes
    }

    
    const refreshFinancials=(companyId)=>{
        axios({
            url: `${process.env.REACT_APP_API_URL}FiscalInput?companyId=${companyId}`,
            method: "Get",
            data:{  },
        }).then((res) => {
            console.log(res.data);
            setFinancials(res.data);
            const uniqueDivisions = [...new Set(res.data.map(item => item.division).filter(Boolean))];
            setDivisions(uniqueDivisions);
            setFilteredFinancials(res.data);
            setDisplayStepper(false);
            // Don't override peers here - keep the full peer group data
        }).catch((err) => {
            console.log(err);
        });
    };

    return (
<div className="container">
        
    <h4>Admin Edit</h4>
    
    {/* Error notification */}
    <Snackbar 
        open={showError} 
        autoHideDuration={6000} 
        onClose={handleCloseError}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{ 
            '& .MuiSnackbarContent-root': { 
                minWidth: '600px',
                maxWidth: '800px'
            }
        }}
    >
        <Alert 
            onClose={handleCloseError} 
            severity="error" 
            sx={{ 
                width: '100%',
                fontSize: '1.2rem',
                padding: '16px 20px',
                '& .MuiAlert-message': {
                    fontSize: '1.2rem',
                    fontWeight: '500'
                }
            }}
            action={
                <Button 
                    color="inherit" 
                    size="large" 
                    onClick={() => {
                        setShowError(false);
                        submitSelectedFinancial();
                    }}
                    sx={{ 
                        fontSize: '1.1rem',
                        padding: '8px 16px',
                        minWidth: '80px'
                    }}
                >
                    Retry
                </Button>
            }
        >
            {uploadError}
        </Alert>
    </Snackbar>

    {/* Success notification */}
    <Snackbar 
        open={showSuccess} 
        autoHideDuration={6000} 
        onClose={handleCloseSuccess}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{ 
            '& .MuiSnackbarContent-root': { 
                minWidth: '600px',
                maxWidth: '800px'
            }
        }}
    >
        <Alert 
            onClose={handleCloseSuccess} 
            severity="success" 
            sx={{ 
                width: '100%',
                fontSize: '1.2rem',
                padding: '16px 20px',
                '& .MuiAlert-message': {
                    fontSize: '1.2rem',
                    fontWeight: '500'
                }
            }}
        >
            {uploadSuccess}
        </Alert>
    </Snackbar>

    {/* Loading notification */}
    <Snackbar 
        open={isUploading} 
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{ 
            '& .MuiSnackbarContent-root': { 
                minWidth: '500px',
                maxWidth: '600px'
            }
        }}
    >
        <Alert 
            severity="info" 
            sx={{ 
                width: '100%',
                fontSize: '1.1rem',
                padding: '16px 20px',
                '& .MuiAlert-message': {
                    fontSize: '1.1rem',
                    fontWeight: '500'
                }
            }}
        >
            Updating fiscal report...
        </Alert>
    </Snackbar>
        
    <div className='componentContainer'>
        {
            !selectedCompany &&
            <div className="formRow">
            <div className="formGroup">
                <CompanyAutoselect allCompanies={props.allCompanies} showAllCompanies={true} onChange={assignCompany} selectText="Company" headerText="Select Company"></CompanyAutoselect>
            </div>
            {/* <div className="formGroup">
                {selectedCompany &&
                <>
                <h5>Select Financial Report</h5>
                <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                label="Select Financial Report"
                                onChange={handleSelect}
                                value={
                                    (selectedFinancial === undefined ||
                                        selectedFinancial === null) ? '0' :
                                        selectedFinancial.fiscalInputId
                                }
                                sx={{ width: 1 }}
                                className="formControl"
                            >
                                <MenuItem key="0" value="0" className="formControl">Select Year and Statement</MenuItem>
                                {financials && financials.length > 0 && 
                                    financials.map((f) => {
                                        return <MenuItem key={f.fiscalInputId} value={f.fiscalInputId} className="formControl">
                                            {(f.fiscalEnd !== null && f.fiscalEnd !== undefined && f.fiscalEnd.length > 0) 
                                                ? format(f.fiscalEnd, 'yyyy') +" (" + format(f.reportDate, 'MMMM') + ")"
                                                : ''} {f.isYTD ? "YTD" : ""}
                                        </MenuItem>
                                    })
                                }
                            </Select>
                </>
                }
            </div> */}
            </div>
        }
        
        {
            selectedCompany &&
            <div className='componentContainer'>
                <div className='stepContainer'>                    
                    {!displayStepper?
                        //Select an input to edit or enter new
                        <FinancialPicker
                        displayStepper={displayStepper} 
                            setDisplayStepper={setDisplayStepper} 
                            defaultFinancial={defaultFinancial}
                            financials={filteredFinancials} 
                            selectedFid={selectedFid} 
                            setSelectedFid={setSelectedFid} 
                            selectedFinancial={selectedFinancial} 
                            setSelectedFinancial={setSelectedFinancial} 
                            allowNew={false}
                            divisions={divisions}
                            selectedDivision={selectedDivision}
                            setSelectedDivision={setSelectedDivision}
                            >
                            
                        </FinancialPicker>
                    :
                        <FinancialStepper selectedFinancial={selectedFinancial} setSelectedFinancial={setSelectedFinancial} className='stepper' submitValues={submitSelectedFinancial} peerGroups={peers}></FinancialStepper>
                    }
                    
                    
                </div>
            </div>
        }
    </div>
</div>
    )
}

